// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a11731e5","160":"5b33cb14","208":"1a99a90a","293":"f7e95398","516":"f19d37aa","519":"9814b2e9","917":"619bcff9","946":"313cf7a2"}[chunkId] + ".chunk.js";
};